export function getUID(prefix: string = ''): string {
  return `${prefix}${Math.random().toString(16).slice(2)}`;
}
